import { AssistedImportRepository } from '@lib/api/repository/assisted-import/assisted-import.repository';
import { AssistedImportFilters } from '@lib/types';

export default class AssistedImportService {
  constructor(private repository: AssistedImportRepository) {}

  createAssistedImportRequest(notes?: string, source?: string) {
    return this.repository.createAssistedImportRequest(notes, source);
  }

  listAdminAssistedImportRequests(filters?: AssistedImportFilters, signal?: AbortSignal) {
    return this.repository.listAdminAssistedImportRequests(filters, signal);
  }

  updateAssistedImportRequestStatus(
    id: string,
    status: 'pending' | 'contacted' | 'completed' | 'cancelled',
    notes?: string,
  ) {
    return this.repository.updateAssistedImportRequestStatus(id, status, notes);
  }
}
